<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col md="12">
                <v-card width="100%">
                    <v-card-title class="d-block text-center font-weight-bold primary warning--text py-2"
                                  style="word-break: normal">METODOS DE PAGO
                    </v-card-title>
                    <v-btn bottom color="warning primary--text" depressed fab absolute right small @click="getData(1)">
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12">
                <v-card>
                    <v-row justify="center" class="mx-0">
                        <v-col cols="12">
                            <v-btn color="primary" large block depressed @click="get" style="margin: 1px">
                                <v-icon>mdi-plus-circle</v-icon>&nbsp;&nbsp;Nuevo Metodo de Pago</v-btn>
                        </v-col>
                    </v-row>
                    <v-card-title>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details/>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="desserts" :search="search" :loading="loading"
                                  :no-data-text="noDataText" :footer-props="footerProps">
                        <template v-slot:item.name="{ item }">
                            <img :src="'/' + item.img" :alt="item.name" height="32px"/>
                            <br/>
                            <b>{{ item.name }}</b>
                        </template>
                        <template v-slot:item.content="{ item }">
                            <div v-html="item.content"/>
                        </template>
                        <template v-slot:item.cname="{ item }">
                            <img :src="'/img/country/' + item.country + '.png'" :alt="item.cname" height="24px"/>
                            <br/>
                            <b>{{ item.cname }}</b>
                        </template>
                        <template v-slot:item.status="{ item }">
                            <v-icon :class="item.status === 1 ? 'success--text' : 'error--text'">{{ item.status === 1 ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                            <br/>
                            <b :class="item.status === 1 ? 'success--text' : 'error--text'">&nbsp;&nbsp;{{ item.status === 1 ? 'Visible' : 'Oculto' }}</b>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-btn color="tertiary" dark small depressed @click="get(item.id)" style="margin: 1px">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card>
                <v-dialog v-model="dialog" scrollable persistent max-width="1000px">
                    <v-form ref="form" @submit.prevent="submit" lazy-validation v-model="valid">
                        <v-card>
                            <v-progress-linear indeterminate fixed v-if="loading" style="top:0"/>
                            <v-card-title class="text-center headline primary warning--text d-inline-block"
                                          style="color: #ffffff; word-break: normal; width: 100%">{{ form.id ? 'Editar' : 'Nuevo' }} Metodo de Pago</v-card-title>
                            <v-card-text>
                                <v-row justify="center">
                                    <v-col cols="12" sm="8" class="text-center">
                                        <img src="/img/no-image.png" width="240px" alt="imagen" style="border: 1px solid #eee; border-radius: 4px;" v-if="imgData === null"/>
                                        <img :src="imgData" width="240px" alt="imagen" style="border: 1px solid #eee; border-radius: 4px;" v-else/>
                                    </v-col>
                                </v-row>
                                <v-row justify="center">
                                    <v-col cols="12" sm="6" md="5">
                                        <v-file-input
                                            :label="labels.img"
                                            v-model="form.img"
                                            name="img"
                                            accept="image/*"
                                            :error-messages="errors.img"
                                            :disabled="loading"
                                            prepend-icon="mdi-panorama"
                                            @input="clearErrors('img')"
                                            @click:clear="clearImg"
                                            show-size counter/>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="5">
                                        <v-text-field
                                            :label="labels.name"
                                            v-model="form.name"
                                            type="text"
                                            name="name"
                                            :error-messages="errors.name"
                                            :rules="[rules.required('name'), rules.min('name', 3, 'El'), rules.max('name', 120, 'El')]"
                                            :disabled="loading"
                                            prepend-icon="mdi-bank"
                                            @input="clearErrors('name')"/>
                                    </v-col>
                                </v-row>
                                <v-row justify="center">
                                    <v-col cols="12" sm="6" md="5">
                                        <v-select
                                            :label="labels.country"
                                            :items="countries"
                                            name="country"
                                            v-model="form.country"
                                            :error-messages="errors.country"
                                            :disabled="loading"
                                            :rules="[rules.required('country')]"
                                            @select="clearErrors('country')"
                                            prepend-icon="mdi-map-marker"
                                            item-text="name"
                                            item-value="code">
                                            <template v-slot:selection="{ item }">
                                                <v-flex>
                                                    <v-avatar size="28px">
                                                        <img :src="'/img/country/' + item.code + '.png'" :alt="item.name.toLowerCase()" />
                                                    </v-avatar>
                                                    <span class='ml-1'>{{ item.name }}</span>
                                                </v-flex>
                                            </template>
                                            <template v-slot:item="{ item }">
                                                <v-list-item-avatar>
                                                    <img :src="'/img/country/' + item.code + '.png'" :alt="item.name.toLowerCase()" />
                                                </v-list-item-avatar>
                                                <v-list-item-content>
                                                    <v-list-item-title v-html="item.name"/>
                                                </v-list-item-content>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="5">
                                        <v-select
                                            :label="labels.status"
                                            :items="options"
                                            name="status"
                                            v-model="form.status"
                                            :error-messages="errors.status"
                                            :disabled="loading"
                                            :rules="[]"
                                            @select="clearErrors('status')"
                                            prepend-icon="mdi-eye"
                                            item-text="name"
                                            item-value="value">
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" md="10">
                                        <ckeditor v-model="form.content" :editorUrl="editorUrl" :config="editorConfig"/>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-divider/>
                            <v-card-actions>
                                <v-btn color="error" @click="close(1)">
                                    <v-icon>mdi-close-circle</v-icon>&nbsp;&nbsp;Cerrar
                                </v-btn>
                                <v-spacer/>
                                <v-btn type="submit" :loading="loading" color="success" :disabled="loading || !valid">
                                    <v-icon>mdi-check-circle</v-icon>&nbsp;&nbsp;{{ form.id ? 'Actualizar' : 'Guardar' }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';
    import Form from "../../../helpers/form";

    export default {
        name: "configBanks",
        mixins: [Form],
        props: ['user'],
        data: () => ({
            search: '',
            headers: [
                { text: 'Banco', value: 'name', align: 'center' },
                { text: 'Información', value: 'content', align: 'center' },
                { text: 'Pais', value: 'cname', align: 'center' },
                { text: 'Estado', value: 'status', align: 'center', filterable: false, sortable: false },
                { text: 'Acción', value: 'action', align: 'center', filterable: false, sortable: false }
            ],
            desserts: [],
            loading: true,
            noDataText: 'No tienes bancos registrados',
            footerProps: {
                itemsPerPageOptions: [50, 100, 250, 500, -1]
            },
            dialog: false,
            countries: [
                { name: 'Brasil', code: 'BRA' },
                { name: 'Chile', code: 'CHL' },
                { name: 'Colombia', code: 'COL' },
                { name: 'Ecuador', code: 'ECU' },
                { name: 'Europa', code: 'EUR' },
                { name: 'Mexico', code: 'MEX' },
                { name: 'Panama', code: 'PAN' },
                { name: 'Peru', code: 'PER' },
                { name: 'Estados Unidos', code: 'USA' },
                { name: 'Venezuela', code: 'VEN' },
                { name: 'Todos', code: '000' }
            ],
            options: [
                { name: 'Visible', value: 1 },
                { name: 'Oculto', value: 0 }
            ],
            labels: {
                name: 'Nombre del Banco',
                content: 'Información',
                country: 'País',
                img: 'Logo',
                status: 'Estado'
            },
            form: {
                id: null,
                name: null,
                content: null,
                country: null,
                img: null,
                status: null
            },
            imgData: null,
            editorUrl: 'https://cdn.ckeditor.com/4.22.1/full-all/ckeditor.js',
            editorConfig: {
                toolbarGroups: [
                    { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                    { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                    { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                    { name: 'forms', groups: [ 'forms' ] },
                    '/',
                    { name: 'colors', groups: [ 'colors' ] },
                    { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                    { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                    '/',
                    { name: 'links', groups: [ 'links' ] },
                    { name: 'insert', groups: [ 'insert' ] },
                    { name: 'styles', groups: [ 'styles' ] },
                    { name: 'tools', groups: [ 'tools' ] },
                    { name: 'others', groups: [ 'others' ] },
                    { name: 'about', groups: [ 'about' ] }
                ],
                removeButtons: 'Save,NewPage,Preview,Print,Templates,Flash,Maximize,ShowBlocks,About',
                removeDialogTabs: 'image:advanced;link:advanced',
                autoParagraph: false,
                format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
                extraAllowedContent: 'span;ul;li;table;th;td;br;center;style;*[id];*(*);*{*}',
                resize_enabled: false,
                enterMode: 'CKEDITOR.ENTER_P',
                shiftEnterMode: 'CKEDITOR.ENTER_BR',
                toolbarCanCollapse: true,
                language: 'es',
                height: '300'
            }
        }),
        created() {
            this.getData();
        },
        watch: {
            'form.img'() {
                if (this.form.img) {
                    this.getImg();
                }
            }
        },
        methods: {
            getData(v) {
                this.loading = true;
                if (v === 1) { this.desserts = []; }
                axios.get('/api/settings/gateways').then((res) => {
                    if (res.data.gateways) {
                        this.desserts = res.data.gateways;
                    } else {
                        this.$toast.error(res.data.status, {icon: 'mdi-close-circle'});
                        this.$router.push({name: 'Home'});
                    }
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                }).then(() => {
                    this.loading = false;
                });
            },
            getImg() {
                const input = this.form.img;

                if (input) {
                    const reader = new FileReader;
                    reader.onload = e => {
                        this.imgData = e.target.result;
                    };
                    reader.readAsDataURL(input);
                }
            },
            clearImg() {
                this.imgData = null;
                this.form.img = null;
            },
            get(id) {
                if (id) {
                    const items = this.desserts;

                    for (let i = 0; i < items.length; i++) {
                        if (items[i].id === id) {
                            this.form.id = items[i].id;
                            this.form.name = items[i].name;
                            this.form.content = items[i].content;
                            this.form.country = items[i].country;
                            this.form.img = null;
                            this.form.status = items[i].status;
                            this.imgData = '/' + items[i].img;
                        }
                    }
                } else {
                    this.close();
                }
                this.dialog = true;
            },
            close(v) {
                if (v === 1) {
                    this.dialog = false;
                }
                this.form = {
                    id: null,
                    name: null,
                    content: '',
                    country: null,
                    img: null,
                    status: null
                };
                this.imgData = null;
                this.$refs.form.reset();
            },
            submit() {
                if (this.$refs.form.validate()) {
                    this.loading = true;

                    let formData = new FormData();
                    let url = 'add';

                    if (this.form.id) {
                        url = 'edit';
                        formData.append('id', this.form.id);
                    }
                    if (this.form.img) {
                        formData.append('img', this.form.img);
                    }
                    formData.append('name', this.form.name);
                    formData.append('content', this.form.content);
                    formData.append('country', this.form.country);
                    formData.append('status', this.form.status);

                    axios.post('/api/settings/gateways/' + url, formData, {
                        headers: {'Content-Type': 'multipart/form-data'}
                    }).then(res => {
                        if (res.data.v === 'success') {
                            this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
                            this.getData();
                            this.close(1);
                        } else {
                            this.$toast.warning(res.data.status, {
                                timeout: 8000,
                                icon: 'mdi-information',
                                dismissable: false,
                                showClose: true
                            });
                        }
                    }).catch(err => {
                        this.handleErrors(err.response.data.errors);
                    }).then(() => {
                        this.loading = false;
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
